export default __webpack_public_path__ + "static/media/Rectangle 101.1762b4c3.png";